var SCM = SCM || {};

SCM.StickyToolbarHelper = (function () {

    return {
        getStickyToolbarHeight: getStickyToolbarHeight
    };

    function getStickyToolbarHeight() {
        if ($('.js-mobile-nav:visible').length > 0) {  // mobile view
            return $('.js-mobile-nav-sticky').outerHeight();
        }
        else if ($('.js-sticky-toolbar').length > 0 &&
                 $('.js-left-nav-col.mobile').length == 0) {  // standard view
            return 55;
        }
        else {    // no toolbar
            return 0;
        }
    }

})(SCM.StickyToolbarHelper = SCM.StickyToolbarHelper || {});